var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "247.95mm",
    height: "157.24mm",
    viewBox: "0 0 247.95 157.24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.5 19.5h405v405h-405z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5268"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5346"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5356"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5366"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.75 56.25h86.25v87h-86.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5376"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5386"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m446.25 178.5h57v57h-57z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5396"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5468"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594 56.25h86.25v87h-86.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5478"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272.25 174h67.5v66.75h-67.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5510"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558.65 -400.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 558.65 569.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5258)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.625,0,-1.88e-7,5.625,181.5,19.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.134 29.616h-3.75v16.012c1.796 0.636 2.998 2.333 3 4.238v3.915l-4.77 10.335h-44.46l-4.77-10.335v-3.915c0.0022-1.905 1.204-3.602 3-4.238v-16.012h-3.75v-4.5h3.75v-15.75h48v15.75h3.75zm-5.25 0h-1.5v15.75h1.5zm-42 15.81c1.562 0.227 2.939 1.145 3.75 2.5 0.946-1.585 2.654-2.557 4.5-2.56h1.5c1.846 3e-3 3.554 0.975 4.5 2.56 0.946-1.585 2.654-2.557 4.5-2.56h1.5c1.846 3e-3 3.554 0.975 4.5 2.56 0.946-1.585 2.654-2.557 4.5-2.56h1.5c1.846 3e-3 3.554 0.975 4.5 2.56 0.811-1.355 2.188-2.273 3.75-2.5v-15.81h-39zm15 8.132 1.393 9.058h6.213l1.394-9.058v-2.942c-2e-3 -2.07-1.68-3.748-3.75-3.75h-1.5c-2.07 2e-3 -3.748 1.68-3.75 3.75zm25.77 9.058 4.23-9.165v-3.585c0-1.657-1.343-3-3-3h-2.25c-2.07 2e-3 -3.748 1.68-3.75 3.75v3.139l-3.408 8.861zm-6.27-9.14v-2.86c-2e-3 -2.07-1.68-3.748-3.75-3.75h-1.5c-2.07 2e-3 -3.748 1.68-3.75 3.75v3l-1.376 9h6.861zm-21 0.14v-3c-2e-3 -2.07-1.68-3.748-3.75-3.75h-1.5c-2.07 2e-3 -3.748 1.68-3.75 3.75v2.86l3.515 9.14h6.86l-1.366-8.886zm-19.5-3.75v3.585l4.23 9.165h8.175l-3.405-8.861v-3.139c-2e-3 -2.07-1.68-3.748-3.75-3.75h-2.25c-1.657 0-3 1.343-3 3zm3-4.5h1.5v-15.75h-1.5zm45-34.5h-45v14.25h45zm3.75 15.75h-52.5v1.5h52.5z",
    fill: "#000000"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "m278.8 253.01c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.8 253.01c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.3 263.51c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.3 263.51c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.55 263.51c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.55 263.51c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.21 261.35c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.94 1.95 1.94s1.95-0.87 1.95-1.94z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.14 261.54c0-1.07-0.87-1.95-1.94-1.95-1.08 0-1.95 0.88-1.95 1.95 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.94-0.87 1.94-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.55 296.88 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m303.55 296.88 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.05 232.38c0-4.97-7.56-9-16.88-9s-16.87 4.03-16.87 9h4.5c0-2.48 5.54-4.5 12.37-4.5s12.38 2.02 12.38 4.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.05 232.38c0-4.97-7.56-9-16.88-9s-16.87 4.03-16.87 9h4.5c0-2.48 5.54-4.5 12.37-4.5s12.38 2.02 12.38 4.5z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m338.23 218.42-13.48 4.26c-7.45 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.29 16.07 3.93l13.49-4.27z",
    fill: "#000000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m338.23 218.42-13.48 4.26c-7.45 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.29 16.07 3.93l13.49-4.27z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m438.05 220.5 11.46-15.84c6.33-8.74 7.6-18.63 2.84-22.08-4.77-3.45-13.77 0.85-20.1 9.59l-11.46 15.84z",
    fill: "#000000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m438.05 220.5 11.46-15.84c6.33-8.74 7.6-18.63 2.84-22.08-4.77-3.45-13.77 0.85-20.1 9.59l-11.46 15.84z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1979,0,-7.54e-7,1.2083,522.75,56.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.444 45.366-12.348 12.348c-2.051 2.048-5.373 2.048-7.425 0l-12.348-12.348h-13.325l4.9788-29.867c0.296-1.811 1.864-3.138 3.699-3.133h41.416c1.835-5e-3 3.403 1.322 3.699 3.133l4.979 29.867zm-41.925-12h11.667l0.642-9h-10.809zm13.17 0h11.945v-9h-11.302zm26.139 10.5-0.642-9h-12.052v9zm-14.194-9h-12.052l-0.643 9h12.695zm0-12v-9h-10.552l-0.643 9zm1.5 0h11.194l-0.642-9h-10.552zm0 1.5v9h11.944l-0.642-9zm13.448 9h11.666l-1.5-9h-10.809zm0.107 1.5 0.643 9h12.666l-1.5-9zm-16.957 21.787c1.466 1.463 3.838 1.463 5.304 0l11.287-11.287h-27.879zm-12.296-12.787 0.642-9h-11.808l-1.5003 9zm-7.98-28.12-1.187 7.12h10.667l0.642-9h-7.902c-1.101-3e-3 -2.042 0.794-2.22 1.88zm45.856 0c-0.178-1.086-1.119-1.883-2.22-1.88h-7.903l0.643 9h10.667z",
    fill: "#000000"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5386)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.79167 -1.88e-7 -3.77e-7 .79167 446.25 178.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.634 52.924c-0.03 0.391-0.357 0.693-0.75 0.692h-6v5.325c-6e-3 5.341-4.334 9.669-9.675 9.675h-0.15c-1.888 1e-3 -3.735-0.554-5.31-1.596-0.427 0.061-0.858 0.093-1.29 0.096h-0.15c-5.341-6e-3 -9.669-4.334-9.675-9.675v-3.825h-6.75c-0.397 1e-3 -0.725-0.308-0.75-0.704l-3-48c-0.026-0.4134 0.289-0.7694 0.702-0.7951 0.016-1e-3 0.032-0.0014 0.048-0.0014h36c0.198 0.0019 0.387 0.0829 0.525 0.225l9 9c0.155 0.155 0.234 0.37 0.217 0.588zm-16.575 14.192h0.15c4.513-5e-3 8.17-3.662 8.175-8.175v-5.325h-5.25v3.825c-7e-3 4.015-2.491 7.61-6.245 9.035 1.003 0.424 2.081 0.641 3.17 0.64zm-4.934-1.672c3.789-0.794 6.504-4.132 6.509-8.003v-3.825h-9.75v5.325c2e-3 2.556 1.202 4.963 3.241 6.503zm-9.991-8.003c5e-3 4.415 3.514 8.029 7.927 8.162-1.717-1.792-2.677-4.179-2.677-6.662v-5.325h-5.25zm-10.452-51.825 2.906 46.5h6.046v-8.25c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75v8.25h16.5v-8.25c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75v8.25h8.952l-2.906-46.5zm36.075 1.2 2.831 45.3h1.601l2.921-37.964-7.34-7.336c-8e-3 -0.0105-0.013-0.0083-0.012 0z",
    fill: "#000000"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5468)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1979,0,-7.54e-7,1.2083,594,56.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.444 45.366-12.348 12.348c-2.051 2.048-5.373 2.048-7.425 0l-12.348-12.348h-13.325l4.9788-29.867c0.296-1.811 1.864-3.138 3.699-3.133h41.416c1.835-5e-3 3.403 1.322 3.699 3.133l4.979 29.867zm-41.925-12h11.667l0.642-9h-10.809zm13.17 0h11.945v-9h-11.302zm26.139 10.5-0.642-9h-12.052v9zm-14.194-9h-12.052l-0.643 9h12.695zm0-12v-9h-10.552l-0.643 9zm1.5 0h11.194l-0.642-9h-10.552zm0 1.5v9h11.944l-0.642-9zm13.448 9h11.666l-1.5-9h-10.809zm0.107 1.5 0.643 9h12.666l-1.5-9zm-16.957 21.787c1.466 1.463 3.838 1.463 5.304 0l11.287-11.287h-27.879zm-12.296-12.787 0.642-9h-11.808l-1.5003 9zm-7.98-28.12-1.187 7.12h10.667l0.642-9h-7.902c-1.101-3e-3 -2.042 0.794-2.22 1.88zm45.856 0c-0.178-1.086-1.119-1.883-2.22-1.88h-7.903l0.643 9h10.667z",
    fill: "#000000"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.579 25.759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5500)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9375 -1.88e-7 -3.77e-7 .92708 272.25 174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5510)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.884 49.866c0 1.657-1.343 3-3 3h-25.5v11.25h-16.5v-11.25h-3c-1.657 0-3-1.343-3-3v-9l-4.5-10.5v-19.5h60v19.5l-4.5 10.5zm-43.5 12.75h13.5v-21h-13.5zm46.5-50.25h-57v11.25h57zm0 17.692v-4.942h-57v4.942l4.378 10.217 0.122 0.283v9.308c0 0.828 0.672 1.5 1.5 1.5h3v-11.25h16.5v11.25h25.5c0.828 0 1.5-0.672 1.5-1.5v-9.308l0.121-0.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 56.616h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 51.366h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 46.116h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.634 40.116h18.75v8.25h-18.75zm1.5 6.75h15.75v-5.25h-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.384 15.366c1.45 0 2.625 1.175 2.625 2.625s-1.175 2.625-2.625 2.625-2.625-1.175-2.625-2.625 1.175-2.625 2.625-2.625zm0 3.75c0.621 0 1.125-0.504 1.125-1.125s-0.504-1.125-1.125-1.125-1.125 0.504-1.125 1.125 0.504 1.125 1.125 1.125z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.029cee877f866af02a19f89b83b78be1.svg";
export { ForwardRef as ReactComponent };